import "core-js/modules/es6.object.assign";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
import { renderFormMixins } from '@/mixins/renderFormMixins';
export default {
  name: "addRole",
  mixins: [renderFormMixins],
  data: function data() {
    return {
      // states:[
      //   {
      //     value:0,
      //     label:"禁用"
      //   },
      //   {
      //     value:1,
      //     label:"启用"
      //   }
      // ],
      formModel: {
        group_name: null,
        // state:null,
        group_desc: null
      },
      formRules: {
        group_name: [{
          required: true,
          message: this._vm.$t('请输入角色名称'),
          trigger: 'blur'
        }],
        group_desc: [{
          required: true,
          message: this._vm.$t('请输入角色说明'),
          trigger: 'blur'
        }] // state:[
        //   { required: true,type:'number', message: '请选择状态', trigger: 'change' }
        // ]

      }
    };
  },
  props: {
    _vm: {},
    edit: {},
    setData: {}
  },
  components: {},
  computed: {},
  methods: {},
  mounted: function mounted() {},
  created: function created() {
    if (this.edit) {
      Object.assign(this.formModel, this.setData);
    }
  }
};